// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstitutionDetail_institution-detail__ttTeU .ant-tag.ant-tag-has-color {
  color: grey;
}

.InstitutionDetail_section__5-8xm {
  width: 100%;
  padding: 40px 0;
  background-color: #ffffff;
}
.InstitutionDetail_section--alt__Grgb0 {
  background-color: #f3f7ff;
}
.InstitutionDetail_section--hero__myqpe {
  padding: 0;
}

@media only screen and (max-width: 480px) {
  .InstitutionDetail_section__5-8xm {
    padding: 24px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/InstitutionDetail.module.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;;AAIA;EACE,WAAA;EACA,eAAA;EACA,yBAAA;AADF;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,UAAA;AAFJ;;AAMA;EACE;IACE,eAAA;EAHF;AACF","sourcesContent":[".institution-detail {\n  :global(.ant-tag.ant-tag-has-color) {\n    color: grey;\n  }\n}\n\n.section {\n  width: 100%;\n  padding: 40px 0;\n  background-color: #ffffff;\n\n  &--alt {\n    background-color: #f3f7ff;\n  }\n\n  &--hero {\n    padding: 0;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .section {\n    padding: 24px 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"institution-detail": `InstitutionDetail_institution-detail__ttTeU`,
	"section": `InstitutionDetail_section__5-8xm`,
	"section--alt": `InstitutionDetail_section--alt__Grgb0`,
	"section--hero": `InstitutionDetail_section--hero__myqpe`
};
export default ___CSS_LOADER_EXPORT___;
